__turbopack_context__.v({
  "author-info-icon": "zDeHZG_author-info-icon",
  "before-text": "zDeHZG_before-text",
  "book-card": "zDeHZG_book-card",
  "book-details-authors": "zDeHZG_book-details-authors",
  "contributor-name": "zDeHZG_contributor-name",
  "view-less-icon": "zDeHZG_view-less-icon",
  "view-more-button": "zDeHZG_view-more-button",
  "view-more-icon": "zDeHZG_view-more-icon",
});
